export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
};

export const NASURL = {
  ROOT: "https://home.esbenjuul.dk/photo/webapi",
};
